import React from "react";
import { DataBox } from "./DataBox";
import { PageHeader } from "./PageHeader";

export function BaseAssetsArchives() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    );
}

